import { Search, X } from "lucide-react";

export default function UnifiedSearchBar({ value, onChange, placeholder }) {
  return (
    <div className="relative w-full">
      <span className="absolute left-6 top-1/2 -translate-y-1/2 text-[#9CA3AF]">
        <Search size={20} />
      </span>
      <input
        data-testid="search-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || "Search people, tools, problems…"}
        className="w-full h-16 pl-14 pr-14 rounded-full bg-white ring-1 ring-[#F3F4F6] focus:ring-2 focus:ring-[#3FFFB6] focus:ring-offset-2 focus:ring-offset-[#FAFAFA] outline-none text-[#111827] placeholder:text-[#9CA3AF] font-body text-base shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-shadow"
      />
      {value && (
        <button
          onClick={() => onChange("")}
          data-testid="search-clear"
          className="absolute right-5 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full flex items-center justify-center text-[#9CA3AF] hover:text-[#111827] hover:bg-[#F3F4F6] transition-colors"
          aria-label="Clear search"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
